import { useQuery } from '@tanstack/react-query'
import { useAccessToken } from '@/features/auth/state/auth'

import api from '@/lib/api'

export function useFetchProductById(id_client: string | undefined) {
  const token = useAccessToken()

  return useQuery({
    queryKey: ['product', id_client],
    queryFn: async () => {
      if (!id_client) throw new Error('ID do produto não fornecido')

      const response = await api.get(`/products/${id_client}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data.data
      } else {
        throw new Error(`Produto com ID ${id_client} não encontrado`)
      }
    },
    enabled: Boolean(token && id_client),
    staleTime: 0
  })
}
